import React from 'react';
import { TaxableReceiptsBreakdownRow } from './taxable-receipts-breakdown-row';
import { TaxableReceiptsGroup } from './taxable-receipts-group';
import { TaxableReceiptsPrimaryRow } from './taxable-receipts-primary-row';

export const TaxableReceiptsGroupComponent = ({ group, providers }) => (
  <TaxableReceiptsGroup index={group.index}>
    <TaxableReceiptsPrimaryRow primaryItem={group.primaryItem} providers={providers} />
    {group.breakdown.map((breakdown, index) =>
      // Only include the breakdown row if there are values
      breakdown.providerValues?.length ? <TaxableReceiptsBreakdownRow key={index} breakdown={breakdown} providers={providers} /> : null
    )}
  </TaxableReceiptsGroup>
);
